import React from 'react';

const EmptyMessage = ({ messageKey, className = '' }) => (
  <p className={'my-4 ' + className}>{messageKey}</p>
)

export default EmptyMessage;